import React from 'react';
import './PostCaptureInfo.css';

interface PostCaptureInfoProps {
  onViewLive?: () => void;
}

const PostCaptureInfo: React.FC<PostCaptureInfoProps> = ({ onViewLive }) => {
  return (
    <div className="pci-banner">
      <div className="pci-icon">📊</div>
      <div className="pci-body">
        <p className="pci-text">
          Stocks here were captured by the screener and are shown <strong>30+ days after capture</strong> or once the trend cycle is complete.
          This helps you study real past performance without influencing active picks.
        </p>
        {onViewLive && (
          <button className="pci-btn" onClick={onViewLive}>
            View Live Stocks →
          </button>
        )}
      </div>
    </div>
  );
};

export default PostCaptureInfo;
